<template>
    <div class="base-input-file">
        <base-file-input
            v-model="model"
            v-validate="{
                required: field.isRequired
            }"
            :input-id="keyBackEnd"
            :input-label="label"
            :file-name-key="field.key"
            :original-file-name-key="originalFileNameKey"
            :urdu-input-label="urduLabel"
            :required ="field.isRequired"
            :disabled = "field.isDisable"
            :placeholder="
                originalFileName || 'Select scan copy (JPG, PNG, or PDF file)'
            "
            drop-placeholder="Drop file here..."
            :file-type="keyBackEnd"
            accept="image/*"
            :data-vv-name="vvName"
            :class="{
                'is-invalid': errors.has(vvName),
            }"
            @update:originalFileName="updateOriginalFileName"
        ></base-file-input>
        <a :href="hyperLink" target="_blank">{{ hyperLinkLabel }}</a>
    </div>
</template>

<script>
import IdentityDocument from './IdentityDocument'
export default {
    // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        validation() {},
    },
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: IdentityDocument, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {}, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            required: false,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            fileNameKey:'',
            originalFileNameKey:'',
            keyBackEnd: '',
            
            urduLabel: '',
            vvName: '',
            isRequired: '',
            isDisable: ''
        }
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        label() {
            let languageOption = this.$store.state.registration.form.languageOption
        if(languageOption =='urd'){
             return this.field.urduLabel 
        } else {
            return this.field.label
        }
        }
    }, // End of Component > data

    watch: {
        modal(newFile) {
            if (newFile && !newFile.type.startsWith('image/')) {
                this.$nextTick(() => {
                    this.file = null
                })
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        
        this.fileNameKey = this.field.fileNameKey
        this.keyBackEnd = this.field.keyBackEnd
        this.originalFileNameKey = this.field.originalFileNameKey
        this.isRequired = this.field.isRequired
        // this.label = this.field.label
        this.urduLabel = this.field.urduLabel
        this.vvName = this.field.vvName
        this.isDisable = this.field.isDisable
       
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
}
</script>
